import React from 'react';

import type { Props } from './index';
import Link from './index';

export const LinkWithRef = React.forwardRef((props: Props, ref: React.Ref<HTMLAnchorElement>) => (
  <Link {...props} innerRef={ref} />
));
